module.exports = __webpack_public_path__ + "static/media/example.596ad477.jpg";